import { useState, useEffect } from 'react';
import axiosInstance from "../../../api/axiosInstance";
import Swal from 'sweetalert2';

export default function MedicalTemplateList({ onSelect, templateType }) {
    const [menuItems, setMenuItems] = useState([]);
    const fetchMenuItems = () => {
        axiosInstance.get(`medicalTemplates/all/${templateType}/1`).then(response => {
            setMenuItems(response.data.data);
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch faviourite menu items. Please try again later.',
            });
            console.error("Error fetching menu items:", error);
        });
    };

    const fetchTemplate = (item) => {
        let templateValue = item.value;
        try {
            templateValue = JSON.parse(templateValue);
        } catch (e) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to parse template value. Please check the template format.',
            });
            console.error("Error parsing template value:", e);
            return;
        }
        const requestTypePart = templateType === "medical_notes" ? "notes" : "prescriptions";
        const requestPayload = templateType === "medical_notes" ? templateValue : { rxList: templateValue };
        axiosInstance.post(`medicalTemplates/fetchInitialValues/${requestTypePart}`, requestPayload).then(response => {
            if (response.data.success !== "success") {
                if (templateType === "medical_notes") {
                    response.data.data.pain_assessment = templateValue.pain_assessment;
                }
                onSelect(response.data.data);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch template data. Please try again later.',
                });
                console.error("Error fetching template data:", response.data);
            }
        }).catch(error => {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch faviourite menu items. Please try again later.',
            });
            console.error("Error fetching menu items:", error);
        });
    };

    useEffect(() => {
        fetchMenuItems();
    }, []);

    const handleItemClick = (e, index) => {
        e.preventDefault();
        e.stopPropagation();
        if (onSelect) {
            fetchTemplate(menuItems[index]);
        }
    };

    return (
        <div class="list-group">
            <div class="list-group-item bg-primary text-white"><i class="fas fa-bookmark"></i>&nbsp;Favourites</div>
            {menuItems.length === 0 ? (
                <div class="list-group-item">N/A</div>
            ) : (
                menuItems.map((item, index) => (
                    <a href="#" key={index} class="list-group-item list-group-item-action" onClick={(e) => handleItemClick(e, index)}>{item.name}</a>
                ))
            )}
        </div>
    );
}